import { axiosGet } from '../axios/httpRequest';

/**
 * 用户列表
 */
export const getStsTokenApi = params => {
    return axiosGet('/api/oss/v1/sts_token', params);
};

export const getPreUrl = params => {
    return axiosGet('/api/oss/v1/preurl', params);
};
